import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import { Content } from "../../_metronic/layout/components/content/Content";
import { userHasModule } from "./roleModuleActions";
import { resolveDefaultLandingRoute } from "./landingRoute";

/**
 * Route guard: only renders the page when the user has the required module.
 * Otherwise redirects to the user's policy-correct landing page.
 */
export function ModuleRoute({ module, component, children, render, ...props }) {
  const { user } = useSelector((state) => state.auth);

  if (!userHasModule(user, module)) {
    return <Redirect to={resolveDefaultLandingRoute(user)} />;
  }

  return (
    <Route {...props}>
      {(routeProps) => {
        if (typeof children === "function") {
          return <Content>{children(routeProps)}</Content>;
        }
        if (!routeProps.match) return null;
        if (children) return <Content>{children}</Content>;
        if (component) {
          return <Content>{React.createElement(component, routeProps)}</Content>;
        }
        if (render) return <Content>{render(routeProps)}</Content>;
        return null;
      }}
    </Route>
  );
}
